export default [
    // Admin routes
    {
        path: '/admin/lead-regions',
        name: 'AdminLeadRegions',
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Lead region groups',
        },
        components: {
            default: () => import('@views/admin/lead-regions/LeadRegionsIndex.vue'),
            agent: () => import('@views/admin/lead-regions/LeadRegionsIndex.vue'),
        },
    },
    {
        path: '/admin/lead-partners/dashboard',
        name: 'AdminLeadSellingDashboard',
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Lead selling dashboard',
        },
        components: {
            default: () => import('@views/admin/lead-partners/LeadSellingDashboard.vue'),
            agent: () => import('@views/admin/lead-partners/LeadSellingDashboard.vue'),
        },
    },
    {
        path: '/distributed-leads',
        name: 'AdminDistributedLeads',
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Distributed leads',
        },
        components: {
            default: () => import('@views/admin/lead-partners/DistributedLeadsIndex.vue'),
            agent: () => import('@views/admin/lead-partners/DistributedLeadsIndex.vue'),
        },
    },
    {
        path: '/admin/lead-regions/:id/view',
        name: 'AdminLeadRegionDetail',
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Lead region details',
        },
        props: {
            default: (route) => ({ id: route.params.id }),
            agent: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/admin/lead-regions/LeadRegionDetail.vue'),
            agent: () => import('@views/admin/lead-regions/LeadRegionDetail.vue'),
        },
    },
    {
        path: '/admin/lead-regions/:groupId/builder',
        name: 'AdminLeadRegionBuilder',
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Region builder',
        },
        components: {
            default: () => import('@views/admin/lead-regions/RegionBuilder.vue'),
            agent: () => import('@views/admin/lead-regions/RegionBuilder.vue'),
        },
    },
    {
        path: '/admin/lead-tiers',
        name: 'AdminLeadTiers',
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Lead packages',
        },
        components: {
            default: () => import('@views/admin/lead-tiers/LeadTiersIndex.vue'),
            agent: () => import('@views/admin/lead-tiers/LeadTiersIndex.vue'),
        },
    },
    {
        path: '/admin/lead-packages',
        name: 'AdminLeadPackages',
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Lead packages',
        },
        components: {
            default: () => import('@views/admin/lead-tiers/LeadTiersIndex.vue'),
            agent: () => import('@views/admin/lead-tiers/LeadTiersIndex.vue'),
        },
    },
    {
        path: '/admin/companies/:id/lead-partner',
        name: 'AdminCompanyLeadPartner',
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Company lead partner management',
        },
        components: {
            default: () => import('@views/admin/companies/CompanyLeadPartnerManagement.vue'),
            agent: () => import('@views/admin/companies/CompanyLeadPartnerManagement.vue'),
        },
    },
    {
        path: '/admin/lead-partners/sa2s',
        name: 'AdminSa2Management',
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'SA2 management',
        },
        components: {
            default: () => import('@views/admin/sa2/Sa2Index.vue'),
            agent: () => import('@views/admin/sa2/Sa2Index.vue'),
        },
    },
    {
        path: '/admin/lead-partners/subscribers',
        name: 'AdminLeadRegionSubscribers',
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Region subscriptions',
        },
        components: {
            default: () => import('@views/admin/lead-partners/LeadRegionSubscribersIndex.vue'),
            agent: () => import('@views/admin/lead-partners/LeadRegionSubscribersIndex.vue'),
        },
    },
    {
        path: '/admin/lead-partners/carry-forwards',
        name: 'AdminLeadCreditCarryForwards',
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Credit rollover requests',
        },
        components: {
            default: () => import('@views/admin/lead-partners/LeadCreditCarryForwardsIndex.vue'),
            agent: () => import('@views/admin/lead-partners/LeadCreditCarryForwardsIndex.vue'),
        },
    },
    {
        path: '/admin/lead-partners/companies/:companyId/lead-wallets/:walletId/transactions',
        name: 'AdminLeadPartnerWalletTransactions',
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Credit history',
        },
        components: {
            default: () => import('@views/admin/lead-partners/CompanyLeadCreditTransactions.vue'),
            agent: () => import('@views/admin/lead-partners/CompanyLeadCreditTransactions.vue'),
        },
    },
    {
        path: '/admin/lead-partners/waitlists',
        name: 'AdminLeadRegionWaitlists',
        redirect: { name: 'AdminLeadRegionSubscribers', query: { tab: 'waitlists' } },
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Region waitlists',
        },
        components: {
            default: () => import('@views/admin/lead-partners/LeadRegionWaitlistsIndex.vue'),
            agent: () => import('@views/admin/lead-partners/LeadRegionWaitlistsIndex.vue'),
        },
    },
    {
        path: '/admin/lead-partners/sync-issues',
        name: 'AdminLeadRegionSyncIssues',
        redirect: { name: 'AdminLeadRegionSubscribers', query: { tab: 'issues' } },
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Sync issues',
        },
    },
    {
        path: '/admin/lead-partners/settings/lead-distribution',
        name: 'AdminLeadDistributionSettings',
        meta: {
            requiresAuth: true,
            roles: ['SUPER', 'MUVAL_ADMIN'],
            title: 'Lead distribution settings',
        },
        components: {
            default: () => import('@views/admin/lead-partners/LeadDistributionSettings.vue'),
            agent: () => import('@views/admin/lead-partners/LeadDistributionSettings.vue'),
        },
    },
];
